import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useCallback } from 'react';
import { preventDefault } from 'shared/hooks/utils';
import { FormControl, FormHelperText, FormLabel, InputLabel } from '@mui/material';
import { LabelWithIcon } from 'console/shared/components/fields/label-with-icon';
function ControlImpl(props, ref) {
    const { validation_result, validation_warnings_result, embedded_label, label, field, value, onChange, helper_text, onComplete, sxProps = { justifyContent: 'flex-end' }, } = props;
    const has_warning = validation_result == null && validation_warnings_result != null;
    const has_error = validation_result != null;
    const is_validation_failed = validation_result != null || validation_warnings_result != null;
    const _onComplete = useCallback((e) => {
        if (e?.key === 'Enter') {
            preventDefault(e);
            onComplete?.();
        }
    }, [onComplete]);
    return (_jsxs(FormControl, { color: has_warning ? 'warning' : undefined, fullWidth: true, error: has_error, focused: is_validation_failed, ref: ref, sx: sxProps, children: [embedded_label ? (_jsx(InputLabel, { children: label })) : (_jsx(FormLabel, { children: _jsx(LabelWithIcon, { has_error: has_error, has_warning: has_warning, ...props }) })), field({
                value,
                onChange,
                label: embedded_label ? label : undefined,
                onComplete: onComplete != null ? _onComplete : undefined,
            }), is_validation_failed && (_jsx(FormHelperText, { error: has_error, required: has_warning, children: _jsx(_Fragment, { children: validation_result ?? validation_warnings_result }) })), helper_text && _jsx(FormHelperText, { children: helper_text })] }));
}
export const Control = memo(forwardRef(ControlImpl));
